
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../config";
import { showError, showSuccess } from '../../utils/dialog';
import "../../Styles/AccessibilityStndCustmer.css";
import { FaPlus, FaTrash } from "react-icons/fa";
import TimeDropdown from "../../components/TimeDropdown ";
import talentLogo from "../../assets/talentlogo2.png";

const Availability = () => {




  const navigate = useNavigate();
  const itemId = "availability";
  const fieldOrder = [
    "date",
    "employeeName",
    "employeeSignature",
    "availability",
  ];
  //
  const [errors, setErrors] = useState({});

  //!now availability is an object (each day = array of time slots)
  const [formData, setFormData] = useState(() => {
    const saved = localStorage.getItem(
      `form_${localStorage.getItem("accountId")}_${itemId}`
    );
    const initial = saved ? JSON.parse(saved) : {};
    return fieldOrder.reduce((acc, f) => {
      if (f === "availability") {
        acc[f] =
          typeof initial[f] === "object" && initial[f] !== null
            ? initial[f]
            : {};
      } else {
        acc[f] = initial[f] ?? "";
      }
      return acc;
    }, {});
  });

  // useEffect(() => {
  //   const saved = localStorage.getItem(`form_${localStorage.getItem("accountId")}_${itemId}`);
  //   if (saved) {
  //     const raw = JSON.parse(saved);
  //     const normalized = fieldOrder.reduce((acc, f) => {
  //       if (f === "availability") {
  //         acc[f] = Array.isArray(raw[f]) ? raw[f] : [];
  //       } else {
  //         acc[f] = (raw[f] ?? "");
  //       }
  //       return acc;
  //     }, {});
  //     setFormData(normalized);
  //   }
  // }, []);
  //! load data if saved
  useEffect(() => {
    const saved = localStorage.getItem(
      `form_${localStorage.getItem("accountId")}_${itemId}`
    );
    if (saved) {
      const raw = JSON.parse(saved);
      setFormData((prev) => ({
        ...prev,
        availability: raw.availability || {},
      }));
    }
  }, []);

  //!update local storage when formData changes
  useEffect(() => {
    //const anySelected = Array.isArray(formData.availability) && formData.availability.length > 0;
    const hashDays = Object.keys(formData.availability || {}).length > 0;
    const status = hashDays ? "in-progress" : "incomplete";
    // Update local
    const accountId = localStorage.getItem("accountId");
    localStorage.setItem(`status_${accountId}_${itemId}`, status);
    localStorage.setItem(
      `form_${accountId}_${itemId}`,
      JSON.stringify(formData)
    );
  }, [formData]);

  //! checkbox (select/unselect day)
  const handleCheckboxChange = (day) => {
    setFormData((prev) => {
      const newAvail = { ...prev.availability };
      if (newAvail[day]) {
        delete newAvail[day]; // uncheck → remove day
      } else {
        newAvail[day] = [{ start: "", end: "" }]; // add day with 1 empty slot
      }
      return { ...prev, availability: newAvail };
    });
  };

  // ! change start or end time
  const handleTimeChange = (day, index, field, value) => {
    setFormData((prev) => {
      const updated = { ...prev.availability };
      updated[day][index][field] = value;

      // detect conflict
      const conflict = detectConflicts(updated[day]);
      setErrors((prevErr) => ({
        ...prevErr,
        [day]: conflict ? "Conflicting time slots found" : "",
      }));

      return { ...prev, availability: updated };
    });
  };

  //! add new time slot
  const handleAddSlot = (day) => {
    setFormData((prev) => {
      const updated = structuredClone(prev.availability); // ensures deep copy
      if (!Array.isArray(updated[day])) updated[day] = [];
      updated[day] = [...updated[day], { start: "", end: "" }];
      return { ...prev, availability: updated };
    });
  };

  //! delete one slot
  const handleDeleteSlot = (day, index) => {
    setFormData((prev) => {
      const updated = { ...prev.availability };
      updated[day].splice(index, 1);
      if (updated[day].length === 0) delete updated[day]; // if no slot left, remove day
      return { ...prev, availability: updated };
    });
  };

  //! detect conflicts
  //! time utilities — shared across helpers
  const toMinutes = (t) => {
    if (!t) return -1;
    const [time, period] = t.split(" ");
    let [hours, minutes] = time.split(":").map(Number);
    if (period === "PM" && hours !== 12) hours += 12;
    if (period === "AM" && hours === 12) hours = 0;
    return hours * 60 + (minutes || 0);
  };

  //! true when a slot crosses midnight (end < start, both set)
  const isOvernightSlot = (slot) => {
    if (!slot.start || !slot.end) return false;
    return toMinutes(slot.end) < toMinutes(slot.start);
  };

  //! detect conflicts — overnight-aware
  const detectConflicts = (slots) => {
    if (!slots || slots.length < 2) return false;

    // Build intervals; overnight end gets +1440 for correct overlap comparison
    const intervals = slots
      .filter((s) => s.start && s.end)
      .map((s) => {
        const start = toMinutes(s.start);
        const end = toMinutes(s.end);
        const effectiveEnd = end < start ? end + 1440 : end;
        return [start, effectiveEnd];
      });

    const sorted = [...intervals].sort((a, b) => a[0] - b[0]);

    for (let i = 0; i < sorted.length - 1; i++) {
      if (sorted[i][1] > sorted[i + 1][0]) return true;
    }
    return false;
  };

  //! submit
  const handleSubmit = () => {
    // check for conflicts before saving
    for (const day in formData.availability) {
      if (detectConflicts(formData.availability[day])) {
        showError(`Please fix conflicts on ${day} before saving.`);
        return; // stop submission
      }
    }

    const anySelected = Object.keys(formData.availability || {}).length > 0;
    const status = anySelected ? "complete" : "incomplete";
    const accountId = localStorage.getItem("accountId");

    localStorage.setItem(
      `form_${accountId}_${itemId}`,
      JSON.stringify(formData)
    );
    localStorage.setItem(`status_${accountId}_${itemId}`, status);

  // Annotate each slot with nextDay flag so email & backend know about overnight shifts
    const enrichedAvailability = {};
    for (const [d, slots] of Object.entries(formData.availability || {})) {
      enrichedAvailability[d] = slots.map((slot) => ({
        ...slot,
        nextDay: isOvernightSlot(slot),
      }));
    }
    const payload = { status, formData: { ...formData, availability: enrichedAvailability } };
    if (accountId && anySelected) {
      // Persist availability for this item
      axios.post(`${BASE_URL}/api/registration/${accountId}/items/${itemId}/complete`, payload)
        .catch(err => console.error('Failed to save availability:', err))
        .finally(() => {
          axios.post(`${BASE_URL}/api/registration/${accountId}/status/${itemId}`, { status, formData: {} }).catch(() => {});
          showSuccess("Form completed successfully!");
          navigate('/register');
        });
    } else {
      navigate('/register');
    }
  };

  const handleBack = () => navigate("/register");

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-50">
      <div className="w-full max-w-[500px] bg-white shadow-xl rounded-2xl p-6">
        {/* Header */}
        <header className="text-center mb-6" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <img src={talentLogo} alt="Talent Employment Inc." style={{ height: 56, marginBottom: 10 }} />
          <h2 className="text-xl font-semibold text-gray-800" style={{ textAlign: "center" }}>Availability</h2>
        </header>

        {/* Body */}
        <section>
          <p className="text-gray-600 mb-4 text-sm">
            Please select your availability and times.
          </p>

          {[
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ].map((day) => (
            <div
              key={day}
              className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 border-b border-gray-100 pb-3"
            >
              {/* ✅ Checkbox + Label */}
              <label className="flex items-center gap-2 min-w-[100px]">
                <input
                  type="checkbox"
                  checked={!!formData.availability[day]}
                  onChange={() => handleCheckboxChange(day)}
                  className="w-5 h-5 accent-red-600 cursor-pointer"
                />
                <span className="text-gray-800 font-medium">{day}</span>
              </label>

              {/* ✅ Inline time pickers (side by side) */}
              {formData.availability[day] && (
                <div className="flex flex-col max-[50px] sm:items-center gap-3 mt-2 sm:mt-0">
                  {formData.availability[day].map((slot, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-between gap-3 border border-gray-200 rounded-lg p-2 bg-gray-50"
                    >
                      <div className="flex flex-col">
                        <div className="flex items-center gap-2">
                          <TimeDropdown
                            value={slot.start}
                            onChange={(newTime) =>
                              handleTimeChange(day, index, "start", newTime)
                            }
                          />
                          <span className="text-gray-600 font-medium text-sm">
                            to
                          </span>
                          <TimeDropdown
                            value={slot.end}
                            onChange={(newTime) =>
                              handleTimeChange(day, index, "end", newTime)
                            }
                          />
                        </div>
                        {isOvernightSlot(slot) && (
                          <span className="text-xs font-semibold text-blue-600 mt-1 ml-1">
                            (Next Day)
                          </span>
                        )}
                      </div>
                      <div className="flex items-center gap-3">
                        <button
                          type="button"
                          onClick={() => handleAddSlot(day)}
                          className="text-green-600 hover:text-green-700 transition"
                          title="Add Slot"
                        >
                          <FaPlus size={15} />
                        </button>

                        <button
                          type="button"
                          onClick={() => handleDeleteSlot(day, index)}
                          className="text-red-600 hover:text-red-700 transition"
                          title="Delete Slot"
                        >
                          <FaTrash size={15} />
                        </button>
                      </div>
                    </div>
                  ))}
                  {/* error msg  */}
                  {errors[day] && (
                    <div className="w-full sm:w-auto mt-1">
                      <p className="text-red-500 text-xs mt-1 ml-2 sm:ml-0">
                        {errors[day]}
                      </p>
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </section>

        {/* Buttons */}
        <div className="flex justify-center gap-4 mt-6">
          <button
            type="button"
            onClick={handleBack}
            className="border border-gray-300 text-gray-700 px-6 py-2 rounded-md font-medium hover:bg-gray-100 transition"
          >
            Back
          </button>
          <button
            type="submit"
            onClick={handleSubmit}
            className="bg-red-600 text-white px-6 py-2 rounded-md font-medium hover:bg-red-700 transition"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default Availability;
